var React = require('react');

function QuarterCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.16","d":"M368 -6.97374e-06C368 203.793 203.241 369 0 369","stroke":"#5478DE"}));
}

QuarterCircleInline.defaultProps = {"viewBox":"0 0 369 370","fill":"none"};

module.exports = QuarterCircleInline;

QuarterCircleInline.default = QuarterCircleInline;
